import React from 'react';
import _ from 'lodash';
import { Surface, Symbols } from 'recharts';
import { useTranslation } from 'react-i18next';

import { Pulldown, Visibility } from 'jbc-front/components/icons';

import { LegendBar, Table, TableHead, TableBody, InnerTable, VisibleButton, TableTitle } from '../styles/ExpenseSummaryStyle';

const CustomizedLegend = ({ payload = [], setDisabledItems, setReverse, reverse, disabledItems, handleClick }) => {
  const { t } = useTranslation();
  return (
    <LegendBar>
      <Table>
        <TableHead>
          <VisibleButton onClick={() => setDisabledItems([])}>
            <Visibility size={13} />
          </VisibleButton>

          <TableTitle
            onClick={() => {
              setReverse(!reverse);
            }}
          >
            {t('features.Dashbord.components.CustomizedLegend.list')}
            <div style={reverse ? { transform: 'rotate(180deg)' } : {}}>
              <Pulldown size={7} />
            </div>
          </TableTitle>
        </TableHead>

        <TableBody>
          {payload.map(entry => {
            const { dataKey, color } = entry;
            const disable = _.includes(disabledItems, dataKey);
            const style = {
              color: disable ? '#AAA' : '#000',
              cursor: !disable && disabledItems.length === payload.length - 1 ? 'not-allowed' : 'pointer'
            };
            return (
              <InnerTable key={dataKey} onClick={() => handleClick(dataKey, payload.length)} style={style}>
                <span style={{ flex: '6%', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Surface width={10} height={10}>
                    <Symbols cx={5} cy={5} type="circle" size={100} fill={color} />
                    {disable && <Symbols cx={5} cy={5} type="circle" size={25} fill={'#FFF'} />}
                  </Surface>
                </span>

                <span style={{ marginLeft: 10, flex: '94%' }}>{dataKey}</span>
              </InnerTable>
            );
          })}
        </TableBody>
      </Table>
    </LegendBar>
  );
};

export default CustomizedLegend;
